<div class="p-grid">
	<div class="p-col-12 p-md-6">
		<p-fieldset legend="Payment Acceptance">
			<div class="d-flex ms-4">
				<div class="d-flex flex-column flex-fill">
					<div class="d-flex justify-content-between">
						<div>Gift Card Payment</div>
						<div class="d-flex justify-content-end">
							<p-inputSwitch
								[(ngModel)]="onDevice.features.giftCardPay"
								(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
							></p-inputSwitch>
						</div>
					</div>
					<div class="d-flex justify-content-between">
						<div>Cash Payment</div>
						<div class="d-flex justify-content-end">
							<p-inputSwitch
								[(ngModel)]="onDevice.features.cashPay"
								(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
							></p-inputSwitch>
						</div>
					</div>
				</div>
			</div>
		</p-fieldset>
	</div>
	<div class="p-col-12 p-md-6">
		<p-fieldset legend="Features">
			<div class="d-flex ms-4">
				<div class="d-flex flex-column flex-fill">
					<div class="d-flex justify-content-between">
						<div>Survey Prompt</div>
						<div class="d-flex justify-content-end">
							<p-inputSwitch
								(onChange)="changesToSave = true"
								[(ngModel)]="onDevice.features.survey"
								(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
							></p-inputSwitch>
						</div>
					</div>
					<div class="d-flex justify-content-between">
						<div>Loyalty Prompt</div>
						<div class="d-flex justify-content-end">
							<p-inputSwitch
								[(ngModel)]="onDevice.features.loyalty"
								(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
							></p-inputSwitch>
						</div>
					</div>
					<div class="d-flex justify-content-between">
						<div>Manager Functions</div>
						<div class="d-flex justify-content-end">
							<p-inputSwitch
								[(ngModel)]="onDevice.features.manager"
								(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
							></p-inputSwitch>
						</div>
					</div>
					<div class="d-flex justify-content-between">
						<div class="d-flex flex-column">
							<div>Prompt for Table Number (always)</div>
							<div class="descriptionText">requires On Build 1.208+</div>
						</div>
						<div class="d-flex justify-content-end">
							<p-inputSwitch
								[(ngModel)]="onDevice.features.promptTableNumber"
								(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
							></p-inputSwitch>
						</div>
					</div>
					<div class="d-flex justify-content-between">
						<div class="d-flex flex-column">
							<div>Menu Item Position Prompt</div>
							<div class="descriptionText">requires On Build 1.208+ and Prompt for Position on Menu Item</div>
						</div>
						<div class="d-flex justify-content-end">
							<p-inputSwitch
								[(ngModel)]="onDevice.features.promptPosition"
								(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
							></p-inputSwitch>
						</div>
					</div>
				</div>
			</div>
		</p-fieldset>
	</div>
</div>
